import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { callCallableNativeSafe } from '../../utils/callableNativeSafe';

export default function LoyaltyWalletDelivery({ businessId, customerId, programId }) {
  const [delivery, setDelivery] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const running = useRef(false);
  const issue = async () => {
    if (running.current) return;
    running.current = true; setBusy(true); setMessage(''); setDelivery(null);
    try {
      const result = await callCallableNativeSafe({ functionName: 'issueCustomerLoyaltyWallet', data: { businessId, customerId, programId }, timeoutMs: 65000 });
      if (!result?.data?.url) throw new Error('No se recibió el enlace de la tarjeta.');
      setDelivery(result.data);
    } catch (_) { setMessage('No pudimos preparar la tarjeta. Revisa la conexión y la configuración de Wallet, e inténtalo nuevamente.'); }
    finally { running.current = false; setBusy(false); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(delivery.url); setMessage('Enlace copiado. Compártelo únicamente con este cliente.'); }
    catch (_) { setMessage('No se pudo copiar automáticamente. Selecciona y copia el enlace de abajo.'); }
  };
  return <div className="loyalty-delivery" style={{ marginTop: 16 }}>
    <button type="button" disabled={busy} onClick={issue}>{busy ? 'Preparando tarjeta…' : delivery ? 'Generar otro enlace' : 'Entregar tarjeta de Wallet'}</button>
    {delivery && <div style={{ padding: 16, background: '#f2f7f3', borderRadius: 16, marginTop: 12 }}>
      <strong>El cliente escanea y guarda su tarjeta</strong>
      <p>No necesita una cuenta ni instalar Loop. Este QR entrega la tarjeta; no canjea premios.</p>
      <div style={{ background: 'white', padding: 12, width: 'fit-content', margin: '12px auto' }}><QRCodeCanvas value={delivery.url} size={176} marginSize={2} /></div>
      <p>Enlace privado · vence a las {new Date(delivery.expiresAtMs).toLocaleTimeString('es-PA', { hour: '2-digit', minute: '2-digit' })}.</p>
      {(!delivery.googleReady || !delivery.appleReady) && <p role="status">Disponible para {delivery.googleReady ? 'Google Wallet' : 'Apple Wallet'}. No pudimos preparar la otra billetera. Puedes generar otro enlace para reintentar.</p>}
      <button type="button" onClick={copy}>Copiar enlace privado</button>
      <input aria-label="Enlace privado para guardar la tarjeta" readOnly value={delivery.url} onFocus={e => e.target.select()} style={{ width: '100%', boxSizing: 'border-box', marginTop: 12 }} />
      <button type="button" onClick={() => { setDelivery(null); setMessage(''); }}>Ocultar QR</button>
    </div>}
    {message && <p role="status">{message}</p>}
  </div>;
}
